import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import MobileMenu from './MobileMenu';
import HamburgerToggler from './HamburgerToggler';
import { CSSTransition } from 'react-transition-group';
import { HAMBURGER_MENU_ID, navbp } from '../utils/constants';
var MainMobileNavBase = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  @media (min-width: ", ") {\n    display: none;\n    flex: 0;\n  };\n"])), navbp.extraWideViewport);
var MobileNav = function MobileNav(_ref) {
  var onMenuClick = _ref.onMenuClick,
    menuOpenState = _ref.menuOpenState,
    children = _ref.children;
  var nodeRef = React.useRef(null);
  return React.createElement(MainMobileNavBase, null, React.createElement(HamburgerToggler, {
    iconSize: "24",
    onMenuClick: onMenuClick,
    menuOpenState: menuOpenState
  }), React.createElement(CSSTransition, {
    nodeRef: nodeRef,
    mountOnEnter: true,
    unmountOnExit: true,
    "in": menuOpenState.isMenuOpen && menuOpenState.menuId === HAMBURGER_MENU_ID,
    timeout: 400
  }, React.createElement(MobileMenu, {
    ref: nodeRef
  }, children)));
};
MobileNav.displayName = 'MobileNav';
export default MobileNav;